import {memo, type PropsWithChildren} from 'react'

import {lazyWithReload} from '../utils/lazyWithReload'

const NotificationStackContainer = lazyWithReload(async () => ({default: (await import('../../components/Generic/Feedback/NotificationStackContainer.tsx')).NotificationStackContainer}))

export const NotificationStackProvider = memo(function NotificationStackProvider({children}: PropsWithChildren) {
  return <>
    {children}
    <NotificationStackContainer/>
  </>
})
